export default function (...args)
{
	return {
		regex: /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
		filter: /[./-]/g,
		store_mask: '$1$2$3$4$5',
		display_mask: '$1.$2.$3/$4-$5'
	};
}

